<div class="row-wrapper">
  <div class="top">
    <h2 class="font-bold text-lg x-padding">{{ data.title }}</h2>
    <div class="arrows x-padding" *ngIf="isMobile && data.hasArrows">
      <ion-button fill="clear" shape="round" [disabled]="isStart" (click)="scrollLeft()">
        <ion-icon name="arrow-back-outline"></ion-icon>
      </ion-button>
      <ion-button fill="clear" shape="round" [disabled]="isEnd" (click)="scrollRight()">
        <ion-icon name="arrow-forward-outline"></ion-icon>
      </ion-button>
    </div>
  </div>
  <div class="row x-padding" #row [ngClass]="{'desktop': !isMobile}">
    <app-data-card
      *ngFor="let card of data.cards"
      [card]="card"
      [isMobile]="isMobile"
    ></app-data-card>
  </div>
</div>
